/** Hooks for the published launch videos (the Launches page). */
import { useQuery } from "@tanstack/react-query";
import { useApi, type ApiError } from "@/lib/api";
import type { Launch, LaunchDetail } from "@/lib/types";

export function useLaunches() {
  const apiCall = useApi();
  return useQuery<Launch[], ApiError>({
    queryKey: ["launches"],
    queryFn: ({ signal }) => apiCall<Launch[]>("/api/launches", { signal }),
  });
}

export function useLaunch(videoId: string | undefined) {
  const apiCall = useApi();
  return useQuery<LaunchDetail, ApiError>({
    queryKey: ["launches", videoId],
    queryFn: ({ signal }) => apiCall<LaunchDetail>(`/api/launches/${encodeURIComponent(videoId ?? "")}`, { signal }),
    enabled: Boolean(videoId),
    // Playback URLs are signed for 4 hours; refetch well before a long-open tab's expire.
    staleTime: 60 * 60 * 1000,
    refetchInterval: 2 * 60 * 60 * 1000,
  });
}
